import React, { useState } from "react";
import { DragDropContext } from "react-beautiful-dnd";
import { Grid, Button } from "@mui/material";
import DroppableList from "./Components/DroppableList";

const defaultTheme = {
  answerSpot: {
    borderRadius: "4px",
    height: "100%",
    width: "100%",
    padding: "20px",
    background: "rgb(0 0 0 / 20%)",
  },
  choiceSpot: {

  },
  cardRoot: {
    margin: ".2rem",
    borderBottom: "5px solid rgba(0,0,0,.05)",
  },
  listOnDrag: {
    backgroundColor: "rgb(255 115 115 / 20%)",
  },
  dropList: {
    display: "flex",
    flex: "1",
    width: "100%",
    borderRadius: "10px",
    border: "1px solid rgba(0, 0, 0, .05)",
    marginTop: "5px",
    flexDirection: "column",
  },
  dropSite: {
    padding: ".5rem",
  },
  dropSiteGrid: {
    height: "100%",
  },
  choiceSite: {
    padding: ".5rem",
    minHeight: "100%",
  },
  heading: {
    marginBottom: "5px",
    marginLeft: "5px",
  },
  choices: {
    background: "rgba(0,0,0,0)",
  },
  feedBackText: {
    color: "black",
  },
  correctCard: {
    background: "#00af8e !important",
    color: "#fff !important",
  },
  wrongCard: {
    background: "#ef0137 !important",
    color: "#fff !important",
  },
};

const AssociationExercise = ({
  dropList,
  choiceList,
  onFinish,
  buttonText,
  theme = {},
}) => {
  const initialColumns = dropList.reduce((res, item) => {
    res[item] = {
      id: item,
      list: [],
    };
    return res;
  }, {});
  initialColumns.choices = {
    id: "choices",
    list: choiceList,
  };

  const styles = { ...defaultTheme, ...theme };

  const [checking, setChecking] = useState(); //eslint-disable-line no-unused-vars
  const [columns, setColumns] = useState(initialColumns);

  const _calcResult = () => {
    //const columnsCopy = { ...columns };
    let wrongCount = 0;
    let correct = false;
    columns[
      "SQL"
    ].list = columns[
      "SQL"
    ].list.map((x) => {
      if (["1", "4", "5", "6", "9"].includes(x.id)) {
        x.correct = true;
      } else {
        x.correct = false;
        wrongCount++;
      }
      return x;
    });
    columns[
      "NoSQL"
    ].list = columns[
      "NoSQL"
    ].list.map((x) => {
      if (["2", "3", "7", "8", "10"].includes(x.id)) {
        x.correct = true;
      } else {
        x.correct = false;
        wrongCount++;
      }
      return x;
    });
    if (
      columns[
       "SQL"
      ].list.length +
      columns[
       "NoSQL"
      ].list.length ===
      10 &&
      wrongCount === 0
    ) {
      setColumns(columns);
      setChecking(false);
      correct = true;
    } else {
      setColumns(columns);
      setChecking(false);
    }
    onFinish({ correct: correct});
  };


  const onDragEnd = ({ source, destination }) => {
    setChecking(true);
    // Make sure we have a valid destination
    if (destination === undefined || destination === null) return null;

    // Make sure we're actually moving the item
    if (
      source.droppableId === destination.droppableId &&
      destination.index === source.index
    )
      return null;
    // Set start and end variables
    const start = columns[source.droppableId];
    const end = columns[destination.droppableId];

    // If start is the same as end, we're in the same column
    if (start === end) {
      // Move the item within the list
      // Start by making a new list without the dragged item
      const newList = start.list.filter((_, idx) => idx !== source.index);

      // Then insert the item at the right location
      newList.splice(destination.index, 0, start.list[source.index]);

      // Then create a new copy of the column object
      const newCol = {
        id: start.id,
        list: newList,
      };

      // Update the state
      setColumns((state) => ({ ...state, [newCol.id]: newCol }));
      return null;
    } else {
      // If start is different from end, we need to update multiple columns
      // Filter the start list like before
      const newStartList = start.list.filter((_, idx) => idx !== source.index);

      // Create a new start column
      const newStartCol = {
        id: start.id,
        list: newStartList,
      };

      // Make a new end list array
      const newEndList = end.list;

      // Insert the item into the end list
      newEndList.splice(destination.index, 0, start.list[source.index]);

      // Create a new end column
      const newEndCol = {
        id: end.id,
        list: newEndList,
      };

      // Update the state
      setColumns((state) => ({
        ...state,
        [newStartCol.id]: newStartCol,
        [newEndCol.id]: newEndCol,
      }));
      return null;
    }
  };

  return (
    <DragDropContext onDragEnd={onDragEnd} >
      <Grid
        container
        direction={"row"}
        justifyContent={"space-around"}
        alignContent={"space-around"}
        sx={styles.root}
        className='light-text'
      >
        <Grid item xs={6} sx={styles.dropSite}>
          <Grid
            container
            direction="column"
            justifyContent="center"
            alignItems="center"
            sx={styles.dropSiteGrid}
          >
            {Object.entries(columns)
              .filter(([key, value]) => !!key && key !== "choices")
              .map(([key, value]) => (
                <DroppableList
                  heading={value.id}
                  direction={"horizontal"}
                  itemList={value.list}
                  listId={value.id}
                  key={value.id}
                  styles={styles}
                  cardWidth={3}
                />
              ))}
          </Grid>
        </Grid>
        <Grid item xs={6} sx={styles.choiceSite} >
            <>
              <DroppableList
                choiceList
                itemList={columns.choices.list}
                listId={columns.choices.id}
                key={columns.choices.id}
                styles={styles}
                cardWidth={3}
              />
            </>
        </Grid>
      </Grid>
      <Button
        sx={styles.button}
        className="bdo-button"
        onClick={() => {
          _calcResult();
        }}
      >
        {buttonText}
      </Button>

    </DragDropContext>
  );
};

export default AssociationExercise;
